import { useUnsyncHold } from "#webapp/src/components/hooks/useUnsyncHold";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { isSmartHoldByExternalEventId } from "@clockwise/client-commons/src/util/event";
import { logger } from "@clockwise/client-commons/src/util/logger";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

export type RemoveGcalHoldContainerProps = {
  orgId: string | undefined;
};

export const RemoveGcalHoldContainer = ({ orgId }: RemoveGcalHoldContainerProps) => {
  const eventDeleteButtonClicked = useSelector(
    (state: IReduxState) => state.webExtension.eventDeleteButtonClicked,
  );
  const smartHoldToDeleteExternalEventId = useSelector(
    (state: IReduxState) => state.webExtension.smartHoldToDeleteExternalEventId,
  );
  const { externalEventId } = useSelector(
    (state: IReduxState) => state.webExtension.activeViewEvent,
  );

  const [onUnsyncHold] = useUnsyncHold({
    input: { orgId: orgId ?? "", holdId: smartHoldToDeleteExternalEventId },
    onError: (error) => {
      logger.error("Unable to unsync hold", error);
      toast.error("Sorry, there was a problem removing your hold.");
    },
    onCompleted: (data) => {
      if (data.unsyncHold?.success) {
        track(TrackingEvents.SMART_HOLD.UNSYNCED, {
          eventId: smartHoldToDeleteExternalEventId,
          surface: "EventModal",
        });
      }
    },
  });

  useEffect(() => {
    const isEligibleForUnsyc =
      !!orgId &&
      !!eventDeleteButtonClicked &&
      isSmartHoldByExternalEventId(smartHoldToDeleteExternalEventId) &&
      smartHoldToDeleteExternalEventId === externalEventId;

    if (isEligibleForUnsyc) {
      onUnsyncHold();
    }
  }, [
    orgId,
    eventDeleteButtonClicked,
    externalEventId,
    smartHoldToDeleteExternalEventId,
    onUnsyncHold,
  ]);

  return null;
};
